<div class="flex items-start gap-4">
  <div
    class="flex flex-col rounded-lg p-3 max-w-xs w-72 bg-white text-text dark:bg-misc-extra dark:text-contrast border border-border-subtle">
    <!-- Respuesta simple (sin datos mapeables) -->
    <ng-container *ngIf="fallbackText; else flowCard">
      <p class="text-sm">{{ fallbackText }}</p>
    </ng-container>

    <!-- Selecciones del flow mapeadas -->
    <ng-template #flowCard>
      <div
        class="flex items-center gap-2 pb-2 border-b border-border-subtle">
        <i class="fa-solid fa-list-check text-icon-brand"></i>
        <span class="text-sm font-semibold">{{ title }}</span>
      </div>

      <div *ngIf="product" class="flex items-center gap-3 pt-2">
        <img
          *ngIf="product.image"
          [src]="product.image"
          [alt]="product.name"
          class="w-12 h-12 rounded-md object-cover shrink-0" />
        <div class="flex flex-col min-w-0">
          <span class="text-sm font-semibold break-words">{{
            product.name
          }}</span>
          <span *ngIf="product.detail" class="text-xs text-text-tertiary">{{
            product.detail
          }}</span>
        </div>
      </div>

      <div *ngIf="products.length" class="flex flex-col gap-3 pt-2">
        <div *ngFor="let item of products" class="flex items-center gap-3">
          <img
            *ngIf="item.image"
            [src]="item.image"
            [alt]="item.name"
            class="w-12 h-12 rounded-md object-cover shrink-0" />
          <div class="flex flex-col min-w-0">
            <span class="text-sm font-semibold break-words">{{ item.name }}</span>
            <span *ngIf="item.detail" class="text-xs text-text-tertiary">{{ item.detail }}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-1 pt-2">
        <div
          *ngFor="let entry of entries"
          class="flex justify-between gap-3 text-sm">
          <span class="text-text-tertiary shrink-0">{{ entry.label }}</span>
          <span class="text-right font-medium break-words min-w-0">{{
            entry.value
          }}</span>
        </div>
      </div>
    </ng-template>

    <p class="pt-2 text-xs self-end italic">
      {{ message.epoch | date: 'dd/MM/YYYY hh:mm a' }}
    </p>
  </div>
</div>
